import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'carbon-components-react';

class CancelModal extends Component {
  static propType = {
    open: PropTypes.bool,
    onOk: PropTypes.func,
    onCancel: PropTypes.func,
  };

  static defaultProps = {
    open: false,
  };

  render() {
    const { open, onOk, onCancel } = this.props;

    return (
      <Modal
        id="cancel-modal"
        open={open}
        onRequestSubmit={onOk}
        onRequestClose={onCancel}
        modalHeading="Descartar alterações"
        primaryButtonText="Sim"
        secondaryButtonText="Não"
      >
        <p className="v-lg-padding">As alterações serão descartadas, deseja continuar?</p>
      </Modal>
    );
  }
}

export default CancelModal;



// WEBPACK FOOTER //
// ./src/components/Modal/CancelModal.js